import { Component, OnInit } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { SharedService } from 'src/app/services/sharedService';
import { UserSessionService } from 'src/app/services/usersession.service';
import { NotifypopupComponent } from '../../pages/master/notifypopup/notifypopup.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  isLoading: boolean;
  client: any;
  clientIdsessionStorage: string;
  clientId: any;
  showallMenu: boolean = false
  role: any;
  message: any;

  constructor(router: Router,
    public dialog: MatDialog) {
    router.events.forEach((event) => {

      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }

    });

  }

  ngOnInit(): void {
  }



}
